/*
 * @Author: ht 1724552153@qq.com
 * @Date: 2024-12-02 11:36:52
 * @LastEditors: ht 1724552153@qq.com
 * @LastEditTime: 2025-02-19 13:53:22
 * @FilePath: \jisuapp_webapp\src\official-page\tap-pay\TapPay.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { appMethod as app } from '@utils/app';
import OfficialPage from '../OfficialPage';
import './TapPay.less'
// import { TopNav } from '@common/top-nav/TopNav';
import { getCurrentPageQueryParams } from '@utils/tools';
import { Toast, Icon } from 'antd-mobile';
import LoadingPage from '../../frame/loading-page/LoadingPage';
import QRCode from 'qrcode'


let timer = null;

export default class TapPay extends OfficialPage {

  state = {
    paylist:[],
    currentIndex:0,
    iscomplete:false,
    payUrl:''
  }


  constructor(props) {
    super(props)
    document.title = '视频号支付';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    
    // this.GetLivePromotionPendingPayList(options.app_id,options.uniq_id)
    this.startPolling(options.app_id,options.uniq_id)


  }
  
  componentWillUnmount() {
    if(timer){
      clearInterval(timer);
      timer = null;
    }
  }

  // 开启定时
  startPolling = (appids,uniqids)=> { 
    timer = setInterval(() => {
      this.GetLivePromotionPendingPayList(appids,uniqids);
    }, 1000);
  }

  // 暂停轮询
  stopPolling = ()=> {
    if(timer){
      clearInterval(timer);
      timer = null;
    }
  }

  // 获取投手号下所有待支付计划订单
  GetLivePromotionPendingPayList = (appids,uniqids)=>{
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppChannelsPromote/GetLivePromotionPendingPayList',
      // hideLoading: true,
      method: 'post',
      data: {
        app_id:appids,
        uniq_id:uniqids
      },
      success: (res) => {   
      if(res.status == 1){
        this.stopPolling()
        return
      }
       if(res.status == 0){
          that.setState({
            paylist:res.data
          })
          if(that.state.currentIndex + 1 > that.state.paylist.length){

            this.stopPolling()
            return
          }
          if(that.state.paylist[that.state.currentIndex].status == '10'){
              // console.log('生成二维码');
              const canvas = document.createElement('canvas')
              canvas.width = 180
              canvas.height = 180
              console.log(that.state.paylist[that.state.currentIndex].pay_url);
              QRCode.toCanvas(canvas, that.state.paylist[that.state.currentIndex].pay_url, { errorCorrectionLevel: 'H' })
              this.setState({
                payUrl:canvas.toDataURL()
              })
           }else if(that.state.paylist[that.state.currentIndex].status !== '10'){
               that.setState({
                currentIndex: that.state.currentIndex + 1
               })
           }
        }
      },
      fail:(res)=>{
        console.log(res);
        
      }
    })
  }

  // 跳过计划
  skipplan = () => {
    app.showModal({
      content: '确定要跳过该计划吗？',
      // confirmText: '去注册',
      showCancel: true,
      confirmColor: '#437eff',
      confirm: () => {
        this.setState({
          currentIndex: this.state.currentIndex + 1
        });
        if (this.state.currentIndex + 1 >= this.state.paylist.length) {
          this.setState({
            iscomplete:true
          })
          this.stopPolling();
        }
      },
    })
  };


  // 获取生成待支付h5页面二维码
  // GetLivePromotionPendingPayQrCode = ()=>{
  //   let that = this
  //   app.sendRequest({
  //     url: '/index.php?r=pc/AppChannelsPromote/GetLivePromotionPendingPayQrCode',
  //     hideLoading: true,
  //     method: 'POST',
  //     data: {
  //       app_id:'y37X6lY43k',
  //       uniq_id:'sph51OT21my6gO1'
  //     },
  //     success: (res) => {
  //      if(res.status == 0){
          
  //      }
  //     }
  //   })
    
  // }


  render(){
    let  { paylist,currentIndex,iscomplete,payUrl } = this.state 
    if (!paylist || paylist.length === 0) {
      return <LoadingPage />;
    }
    return(
      <div className="tap-pay">
          <div className="pay-hd">
            <div className="pay-hd-lf">
              <img src={paylist[0].headimg_url} alt="" />
            </div>
            <div className="pay-hd-rf">
               <span>{paylist[0].nick_name}</span>
               <span>备注：</span>
            </div>
            

          </div>
          <div className="pay-md">
            <div className="pay-md-top">
              {!iscomplete &&
                <div className="md-top-lf">
                <span>第{currentIndex+1}条计划</span>
                <span>ID:{paylist[currentIndex].promotion_id}</span>
              </div>
              }
            
              {!iscomplete &&
                <div className="md-top-rf" onClick={this.skipplan}>
                  <span>跳过该计划</span>
                </div>
              }
              
            </div>
            <div className="pay-md-code">
              {!iscomplete && payUrl &&
                <div className="code">
                  <img src={payUrl} alt="" />
                </div>
              }
              {iscomplete &&
                 <div className="code-complete">
                    <Icon className="code-icon" color="#00FF00" type="check-circle-o" size='xs'/>
                    <span>订单全部支付完成</span>
                 </div> 
              }
               <span className="code-tip">长按识别图中二维码支付</span>
               <div className="code-btn">
                 <span>剩余{paylist.length - currentIndex}条待支付</span>
               </div>
            </div>
          </div>
          <div className="pay-bd">
            <div className="pay-bd-tip">
              <div className='bd-icon'></div>
              <span className="bd-tip">温馨提示</span>
              <div className='bd-icon'></div>
            </div>
            <div className="pay-bd-content">
              <span>1.此链接包含该投手号的所有待支付计划，使用自动支付脚本需要 关停无需支付的计划，避免错误;</span>
              <span>2.可联系客服领取自动支付脚本。</span>
            </div>
          </div>
         </div>
    
    )
  }

}



// WEBPACK FOOTER //
// ./src/official-page/tap-pay/TapPay.jsx